import { useState } from 'react';

export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

interface FaqAccordionProps {
  items: FaqItem[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openId, setOpenId] = useState<string | null>(items[0]?.id ?? null);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div key={item.id} className="py-1">
            <button
              type="button"
              onClick={() => setOpenId(isOpen ? null : item.id)}
              aria-expanded={isOpen}
              className="w-full flex items-start justify-between gap-4 text-left py-4 cursor-pointer group"
            >
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug">
                {item.question}
              </h3>
              <span
                className={`mt-0.5 w-7 h-7 shrink-0 rounded-full flex items-center justify-center text-lg transition-all duration-300 ${
                  isOpen
                    ? 'bg-primary-500 text-background-50 rotate-45'
                    : 'bg-background-100 text-foreground-700'
                }`}
              >
                <i className="ri-add-line" />
              </span>
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                isOpen ? 'max-h-96 opacity-100 pb-5' : 'max-h-0 opacity-0'
              }`}
            >
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed pr-10">{item.answer}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}